import { createClient } from '@supabase/supabase-js'

// Supabase configuration
const supabaseUrl = 'https://pktgljzmqosacpjuukbo.supabase.co'
const supabaseAnonKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBrdGdsanptcW9zYWNwanV1a2JvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg5MzY5MzYsImV4cCI6MjA4NDUxMjkzNn0.SXVi9QLrXabjhJxqL3JVwaGxO--Ij-zz9e2JlE13Stg'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Database types
export interface Database {
  public: {
    Tables: {
      users: {
        Row: {
          id: string
          email: string
          name: string
          role: string
          avatar: string | null
          language: string
          timezone: string
          created_at: string
        }
        Insert: {
          id?: string
          email: string
          name: string
          role: string
          avatar?: string | null
          language?: string
          timezone?: string
          created_at?: string
        }
        Update: {
          id?: string
          email?: string
          name?: string
          role?: string
          avatar?: string | null
          language?: string
          timezone?: string
          created_at?: string
        }
      }
      patients: {
        Row: {
          id: string
          name: string
          age: number
          gender: string
          phone: string
          email: string
          address: string
          emergency_contact: any
          insurance_id: string | null
          medical_history: any
          interactions: any[]
          created_at: string
        }
        Insert: {
          id?: string
          name: string
          age: number
          gender: string
          phone: string
          email: string
          address: string
          emergency_contact: any
          insurance_id?: string | null
          medical_history?: any
          interactions?: any[]
          created_at?: string
        }
        Update: {
          id?: string
          name?: string
          age?: number
          gender?: string
          phone?: string
          email?: string
          address?: string
          emergency_contact?: any
          insurance_id?: string | null
          medical_history?: any
          interactions?: any[]
          created_at?: string
        }
      }
      doctors: {
        Row: {
          id: string
          name: string
          specialty_id: string
          phone: string
          email: string
          schedule: any
          created_at: string
        }
        Insert: {
          id?: string
          name: string
          specialty_id: string
          phone: string
          email: string
          schedule: any
          created_at?: string
        }
        Update: {
          id?: string
          name?: string
          specialty_id?: string
          phone?: string
          email?: string
          schedule?: any
          created_at?: string
        }
      }
      appointments: {
        Row: {
          id: string
          patient_id: string
          doctor_id: string
          service_id: string
          date: string
          time: string
          duration: number
          status: string
          notes: string
          next_appointment_date: string | null
          next_appointment_notes: string | null
          cancel_reason: string | null
          original_date: string | null
          original_time: string | null
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          patient_id: string
          doctor_id: string
          service_id: string
          date: string
          time: string
          duration: number
          status: string
          notes: string
          next_appointment_date?: string | null
          next_appointment_notes?: string | null
          cancel_reason?: string | null
          original_date?: string | null
          original_time?: string | null
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          patient_id?: string
          doctor_id?: string
          service_id?: string
          date?: string
          time?: string
          duration?: number
          status?: string
          notes?: string
          next_appointment_date?: string | null
          next_appointment_notes?: string | null
          cancel_reason?: string | null
          original_date?: string | null
          original_time?: string | null
          created_at?: string
          updated_at?: string
        }
      }
      services: {
        Row: {
          id: string
          name: string
          duration: number
          price: number
          description: string
        }
        Insert: {
          id?: string
          name: string
          duration: number
          price: number
          description: string
        }
        Update: {
          id?: string
          name?: string
          duration?: number
          price?: number
          description?: string
        }
      }
      insurances: {
        Row: {
          id: string
          name: string
          company: string
          coverage_type: string
          phone: string
          email: string
        }
        Insert: {
          id?: string
          name: string
          company: string
          coverage_type: string
          phone: string
          email: string
        }
        Update: {
          id?: string
          name?: string
          company?: string
          coverage_type?: string
          phone?: string
          email?: string
        }
      }
      specialties: {
        Row: {
          id: string
          name: string
          description: string
        }
        Insert: {
          id?: string
          name: string
          description: string
        }
        Update: {
          id?: string
          name?: string
          description?: string
        }
      }
      contacts: {
        Row: {
          id: string
          name: string
          phone: string
          email: string
          company: string
          position: string
          notes: string
          interactions: any[]
          created_at: string
        }
        Insert: {
          id?: string
          name: string
          phone: string
          email: string
          company: string
          position: string
          notes: string
          interactions?: any[]
          created_at?: string
        }
        Update: {
          id?: string
          name?: string
          phone?: string
          email?: string
          company?: string
          position?: string
          notes?: string
          interactions?: any[]
          created_at?: string
        }
      }
      companies: {
        Row: {
          id: string
          name: string
          industry: string
          size: string
          location: string
          phone: string
          email: string
          website: string | null
          notes: string
          created_at: string
        }
        Insert: {
          id?: string
          name: string
          industry: string
          size: string
          location: string
          phone: string
          email: string
          website?: string | null
          notes: string
          created_at?: string
        }
        Update: {
          id?: string
          name?: string
          industry?: string
          size?: string
          location?: string
          phone?: string
          email?: string
          website?: string | null
          notes?: string
          created_at?: string
        }
      }
      opportunities: {
        Row: {
          id: string
          name: string
          contact_id: string | null
          company_id: string | null
          company: string
          industry: string
          size: string
          location: string
          stage: string
          amount: number
          probability: number
          notes: string
          interactions: any[]
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          name: string
          contact_id?: string | null
          company_id?: string | null
          company: string
          industry: string
          size: string
          location: string
          stage: string
          amount: number
          probability: number
          notes: string
          interactions?: any[]
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          name?: string
          contact_id?: string | null
          company_id?: string | null
          company?: string
          industry?: string
          size?: string
          location?: string
          stage?: string
          amount?: number
          probability?: number
          notes?: string
          interactions?: any[]
          created_at?: string
          updated_at?: string
        }
      }
      clinical_histories: {
        Row: {
          id: string
          patient_id: string
          date: string
          doctor_id: string
          doctor_name: string
          personal_background: any
          clinical_background: any
          diagnosis: string
          treatment: string
          medical_indications: string
          sessions: string
          session_number: string
          comments: string
          doctor_signature: string
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          patient_id: string
          date: string
          doctor_id: string
          doctor_name: string
          personal_background: any
          clinical_background: any
          diagnosis: string
          treatment: string
          medical_indications: string
          sessions: string
          session_number: string
          comments: string
          doctor_signature: string
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          patient_id?: string
          date?: string
          doctor_id?: string
          doctor_name?: string
          personal_background?: any
          clinical_background?: any
          diagnosis?: string
          treatment?: string
          medical_indications?: string
          sessions?: string
          session_number?: string
          comments?: string
          doctor_signature?: string
          created_at?: string
          updated_at?: string
        }
      }
    }
  }
}
